import type { Factura, FacturaPagoHistorialItem } from '../components/facturas/types';

export function parseHistorialPagos(raw: unknown): FacturaPagoHistorialItem[] {
  if (raw == null) return [];
  let arr: unknown[] = [];
  if (Array.isArray(raw)) arr = raw;
  else if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw);
      arr = Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  } else {
    return [];
  }
  return arr.map((x) => {
    const o = x as Record<string, unknown>;
    return {
      monto: Number(o.monto) || 0,
      fecha: o.fecha ? new Date(String(o.fecha)) : new Date(),
      metodo: String(o.metodo ?? o.method ?? '—'),
      saldoDespues: Number(o.saldo_despues ?? o.saldoDespues ?? 0),
      registradoPor: o.registrado_por != null ? String(o.registrado_por) : undefined,
      registradoPorId: o.registrado_por_id != null ? String(o.registrado_por_id) : undefined,
      notas: o.notas != null ? String(o.notas) : undefined,
      comprobanteUrl: o.comprobante_url != null ? String(o.comprobante_url) : undefined,
      reciboUrl: o.recibo_url != null ? String(o.recibo_url) : undefined,
      origen: o.origen != null ? String(o.origen) : undefined,
      creditoId: o.credito_id != null ? String(o.credito_id) : undefined,
      cobroId: o.cobro_id != null ? String(o.cobro_id) : undefined,
      pagoCobroId: o.pago_cobro_id != null ? String(o.pago_cobro_id) : undefined,
    };
  });
}

export function historialPagosToJsonDb(items: FacturaPagoHistorialItem[]): Record<string, unknown>[] {
  return items.map((h) => {
    const row: Record<string, unknown> = {
      monto: h.monto,
      fecha: h.fecha instanceof Date ? h.fecha.toISOString() : String(h.fecha),
      metodo: h.metodo,
      saldo_despues: h.saldoDespues,
    };
    if (h.registradoPor !== undefined) row.registrado_por = h.registradoPor;
    if (h.registradoPorId !== undefined) row.registrado_por_id = h.registradoPorId;
    if (h.notas !== undefined) row.notas = h.notas;
    if (h.comprobanteUrl !== undefined) row.comprobante_url = h.comprobanteUrl;
    if (h.reciboUrl !== undefined) row.recibo_url = h.reciboUrl;
    if (h.origen !== undefined) row.origen = h.origen;
    if (h.creditoId !== undefined) row.credito_id = h.creditoId;
    if (h.cobroId !== undefined) row.cobro_id = h.cobroId;
    if (h.pagoCobroId !== undefined) row.pago_cobro_id = h.pagoCobroId;
    return row;
  });
}

/** Campos a enviar a `updateFactura` tras registrar un abono. */
export function aplicarRegistroPagoAFactura(
  factura: Factura,
  monto: number,
  metodoPago: string,
  comprobanteUrl?: string
): Pick<
  Factura,
  | 'estadoPago'
  | 'montoPagado'
  | 'montoPendiente'
  | 'fechaPago'
  | 'metodoPago'
  | 'comprobanteUrl'
  | 'historialPagos'
  | 'ultimaActividad'
> {
  const montoPagadoNuevo = (factura.montoPagado || 0) + monto;
  const montoPendienteNuevo = Math.max(0, factura.total - montoPagadoNuevo);
  const nuevoEstado: Factura['estadoPago'] =
    montoPendienteNuevo === 0 ? 'PAGADO' : 'PAGO_PARCIAL';
  const ahora = new Date();
  const prev =
    factura.historialPagos && factura.historialPagos.length > 0
      ? [...factura.historialPagos]
      : [];
  const historialPagos: FacturaPagoHistorialItem[] = [
    ...prev,
    { monto, fecha: ahora, metodo: metodoPago, saldoDespues: montoPendienteNuevo },
  ];
  return {
    estadoPago: nuevoEstado,
    montoPagado: montoPagadoNuevo,
    montoPendiente: montoPendienteNuevo,
    fechaPago: montoPendienteNuevo === 0 ? ahora : factura.fechaPago,
    metodoPago: metodoPago || factura.metodoPago,
    comprobanteUrl: comprobanteUrl ?? factura.comprobanteUrl,
    historialPagos,
    ultimaActividad: ahora,
  };
}
